import type { TransportInvoiceDto } from '../../types/transport';
import type { TransportInvoicePayload } from './api/transportRoutesApi';

/**
 * Faktura przewoźnika on the truck card (decision
 * docs/decisions/2026-10-16-faktura-transportowa-na-aucie.md). The backend
 * owns the rule (utils/transportInvoice.js): the invoice amount replaces the
 * plan; this file only prepares what the card shows.
 */
export interface TransportInvoiceComparison {
  /** Invoice − plan, only when both are in the same currency and a plan existed. */
  difference: number | null;
}

export function compareInvoiceWithPlan(invoice: TransportInvoiceDto): TransportInvoiceComparison {
  if (invoice.plannedRate == null || (invoice.plannedCurrency || 'PLN') !== invoice.currency) {
    return { difference: null };
  }
  return { difference: Math.round((invoice.amount - invoice.plannedRate) * 100) / 100 };
}

export interface TransportInvoiceFormValues {
  invoiceNumber: string;
  invoiceIssueDate: { format: (pattern: string) => string } | null;
  invoiceAmount: number | null;
  invoiceCurrency: string;
}

export function toTransportInvoicePayload(values: TransportInvoiceFormValues): TransportInvoicePayload {
  return {
    invoiceNumber: values.invoiceNumber.trim(),
    invoiceIssueDate: values.invoiceIssueDate ? values.invoiceIssueDate.format('YYYY-MM-DD') : '',
    invoiceAmount: Number(values.invoiceAmount),
    invoiceCurrency: values.invoiceCurrency,
  };
}
